import { ReactNode } from 'react'
import { Box, Dialog, DialogContent, Typography, useMediaQuery } from '@mui/material'
import { Theme } from '@mui/material/styles'

export function JourneySheet({
  open,
  title,
  description,
  onClose,
  children,
}: {
  open: boolean
  title: string
  description?: string
  onClose: () => void
  children: ReactNode
}) {
  const desktop = useMediaQuery<Theme>((theme) => theme.breakpoints.up('md'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        '& .MuiDialog-paper': desktop
          ? { maxWidth: 520, borderRadius: 2, m: 'auto' }
          : {
              position: 'fixed',
              bottom: 0,
              m: 0,
              width: '100%',
              maxWidth: '100%',
              borderRadius: '16px 16px 0 0',
            },
      }}
    >
      <DialogContent sx={{ display: 'grid', gap: 2, p: 3 }}>
        <Typography variant="h6">{title}</Typography>
        {description && (
          <Typography color="text.secondary">{description}</Typography>
        )}
        <Box sx={{ display: 'grid', gap: 1 }}>{children}</Box>
      </DialogContent>
    </Dialog>
  )
}
